/**
 * BlurHashItems
 * Mapping page → blurhash string tương ứng.
 *
 * Cách lấy hash: chạy encode() từ thư viện `blurhash` với ảnh preview/thumbnail
 * đại diện của từng trang, hoặc dùng tool online: https://blurha.sh/
 *
 * Hiện tại dùng cùng một hash chung (từ ảnh tổng quan) làm placeholder.
 * Cập nhật từng key khi có ảnh đúng cho mỗi trang.
 */
export const BLUR_HASH_MAP = {
  // Trang Loading
  loading: 'L4HBPN%h00=;04bv~98{00~9.m0M',
  // Trang tổng quan 360 — ảnh preview pano tổng thể
  tongquan: 'L%HyI3t5t7W=t:j?t6oLIvofWAae',

  // Trang tiện ích 360 — ảnh preview pano tiện ích
  tienich: 'LIG+p:D*9d9a~V%MM{-:Dj-ot5%2',

  // Gallery — fallback hash khi ảnh/phim chưa có hash riêng
  gallery: 'L6Pj0^jE.AyE_3t7t7R**0o#DgR4',

  // Brochure — ảnh tài liệu/catalogue kiến trúc
  brochure: 'L4HBPN%h00=;04bv~98{00~9.m0M',

  // Mặt bằng / sơ đồ tầng — bản vẽ kiến trúc nền sáng
  plan: 'LgO:^aNG%Lt6IUofoeoL~qjrIVj]',
};
